<template>
  <div class="offence-container">
    <div class="section-container">
      <div class="title-box">
        <p>廉洁举报 Offence Reporting Centre</p>
        <img
          src="../../../assets/images/offence/logo.png"
          alt=""
        />
      </div>

      <el-row class="mt90 content-box">
        <el-col :span="12">
          <p class="content-title">•&nbsp;声明及承诺</p>
          <p>
            新希望集团审计监察部为董事会领导之独立监督机构，负责公司反舞弊渠道的维护以及案件的调查。我们本着对董事会及举报人负责的态度开展反舞弊工作，承诺对举报者的个人信息及举报内容进行严格保密。
          </p>
        </el-col>
        <el-col :span="12">
          <p class="content-title">•&nbsp;举报范围</p>
          <p>
            “廉洁举报”仅限于对新希望员工违反《新希望集团商业行为准则》行为的举报，其它投诉请通过官网“客户服务热线”解决。
          </p>
        </el-col>
        <el-col :span="12">
          <p class="content-title">•&nbsp;举报责任</p>
          <p>
            1.举报人应遵守国家法律法规，不得损害他人合法利益。<br />2.举报内容应当客观公正，不得捏造、歪曲事实，不得陷害他人。
          </p>
        </el-col>
        <el-col :span="12">
          <p class="content-title">•&nbsp;重要提示</p>
          <p>
            1.鼓励实名举报，我们承诺对实名举报的个人信息及举报内容严格保密，并对调查结果给予及时反馈。<br />2.举报人应尽可能说明事情的基本经过，举报对象的名称、地址、具体当事人，并提供个人利益或公司利益受到侵害的证据或相关资料。
          </p>
        </el-col>
      </el-row>

      <el-row class="jb-box">
        <el-col :span="24">
          <p class="content-title mt60">•&nbsp;举报方式</p>
        </el-col>
        <el-col :span="4">
          <p class="jb-title">邮件举报</p>
          <p class="jb-text">jiancha@newhope.cn</p>
        </el-col>
        <el-col :span="4">
          <p class="jb-title">电话举报</p>
          <p class="jb-text">+86（28）8526 0000</p>
          <p class="jb-text">+86 182 2443 2600</p>
        </el-col>
        <el-col :span="8">
          <p class="jb-title">信件/到访举报</p>
          <p class="jb-text"><strong>收件人</strong>（北京总部）</p>
          <p class="jb-text">北京市朝阳区望京街10号望京SOHO中心T3 ，B座11层</p>
          <p class="jb-text">新希望集团有限公司审计监察部</p>
          <p class="jb-text"><strong>邮编</strong>100102</p>
        </el-col>
        <el-col :span="8">
          <p class="jb-title">&nbsp;</p>
          <p class="jb-text"><strong>收件人</strong>（四川总部）</p>
          <p class="jb-text">四川省成都市锦江区金石路366号中鼎国际2栋22楼</p>
          <p class="jb-text">新希望集团有限公司审计监察部</p>
          <p class="jb-text"><strong>邮编</strong>610063</p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "OffencePage",
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="scss" scoped>
.offence-container {
  .title-box {
    padding: 71px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #6d7173;
    line-height: 35px;
    font-size: 30px;
    color: #3c4347;

    > img {
      width: 60px;
      right: 0;
    }
  }

  .mt90 {
    margin-top: 90px;
  }

  .content-box {
    > div {
      box-sizing: border-box;
      height: 280px;
      padding-top: 50px;
      border-bottom: 1px dashed #7a7a7a;

      > p:nth-child(1n + 2) {
        font-size: 14px;
        color: #7a7a7a;
        line-height: 26px;
        margin-bottom: 8px;
        text-align: justify;
      }
    }
    > div:nth-child(2n + 1) {
      border-right: 1px dashed #7a7a7a;
      padding-right: 60px;
    }

    > div:nth-child(2n + 2) {
      padding-left: 60px;
    }
  }

  .content-title {
    font-size: 28px;
    color: #3c4347;
    line-height: 30px;
    margin-bottom: 25px;
  }

  .mt60 {
    margin-top: 60px;
  }

  .jb-box {
    padding-bottom: 90px;
    border-bottom: 1px solid #6d7173;

    >div {
      padding: 0 30px;
    }

    > div:nth-child(2),
    > div:nth-child(3) {
      box-sizing: border-box;
      padding: 0 20px;
      border-right: 1px dashed #7a7a7a;
      height: 165px;
    }
  }

  .jb-title {
    font-size: 18px;
    color: #3c4347;
    margin-bottom: 22px;
  }

  .jb-text {
    font-size: 14px;
    color: #7a7a7a;
    line-height: 24px;
    margin-bottom: 8px;
    text-align: justify;
    > strong {
      color: #3c4347;
    }
  }
}
</style>
